<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Retrieve Documents</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form novalidate (ngSubmit)="retrieve()" [formGroup]="form" autocomplete="off" *ngIf="(true == loadSearch) && (true != data.hideUserInput)">
        <h2>Document Search Details</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>Item Key Type</label>
                    <select class="mvd_form-control" id="documentCategoryTypes" formControlName="documentItemKeyTypeControl">
                        <option value="">- Select -</option>
                        <option *ngFor="let docItemKey of documentLookups.documentItemKeyTypes" value="{{docItemKey.value}}">{{docItemKey.text}}</option>
                    </select>
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label>Item Key</label>
                    <input class="mvd_form-control" type="text" formControlName="itemKeyControl">
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Category</label>
                    <select class="mvd_form-control" id="documentCategoryTypes" formControlName="documentCategoryTypeControl">
                        <option value="">- Select -</option>
                        <option *ngFor="let category of documentLookups.documentCategoryTypes" value="{{category.value}}">{{category.text}}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Type</label>
                    <select class="mvd_form-control" id="documentType" formControlName="documentTypeControl">
                        <option value="">- Select -</option>
                        <option *ngFor="let type of documentLookups.documentTypes" value="{{type.value}}">{{type.text}}</option>
                    </select>
                </div>
            </div>
            <div class="mvd_form-group">
                <mvm-spinner-btn [btnText]="'Find'"></mvm-spinner-btn>
            </div>
        </fieldset>
    </form>
    <ng-container *ngIf="showResults">
        <h2>Document Results</h2>
        <p-table [value]="documents" sortField="updatedDate" sortOrder="-1" [paginator]="true" [rows]="rowsPerPage" [totalRecords]="documents.length">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="(true != data.disableSelect) ? 6: 5">
                        No Records Found
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>File Name</th>
                    <th>Category </th>
                    <th> Type </th>
                    <th>File Description</th>
                    <th class="w--date-short">Updated</th>
                    <th class="w--icon">View</th>
                    <th *ngIf="true != data.disableSelect" class="w--icon">Select</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                    <td class="td--hover-show">{{row.documentFilename}}</td>
                    <td>{{row.documentCategoryType}}</td>
                    <td>{{row.documentType}}</td>
                    <td>{{row.documentDescription}}</td>
                    <td>{{row.updateDateDisplayValue | date: 'MM/dd/yyyy'}}</td>
                    <td class="text-center">
                        <a *ngIf="row.loading"><i class="fa fa-spinner fa-spin fa-fw fa-2x" style="color:gray;"></i></a>
                        <a class="icon--view" title="View" href="javascript:void(0)" (click)="downloadDocument(row)" *ngIf="!row.loading"></a>
                    </td>
                    <td *ngIf="true != data.disableSelect">
                        <input type="checkbox" (change)="selectDocument(row, $event.target.checked)" />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</div>
<div class="modal-footer">
    <div class="btn--group" *ngIf="!showResults">
        <button type="button" class="btn--primary" data-bs-dismiss="modal" (click)="cancel()">Close</button>
    </div>
    <div class="btn--group" *ngIf="showResults">
        <button class="btn--default" type="button" data-bs-dismiss="modal" (click)="cancel()">Close</button>
        <button class="btn--primary" type="button" data-bs-dismiss="modal" (click)="choose()" *ngIf="true != data.disableSelect">Add Selected</button>
    </div>
</div>
